import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Layout from '../../components/layout/Layout';
import BoilerCreateModal from '../../modal/boiler/BoilerCreateModal';
import Constants from '../../config/constants';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import Alert from '../../modal/alert/Alert';
import DataTable from '../../components/datatable/DataTable';
import Select from 'react-select';
import { defaultRejectHandler, getErrorValue, getStatusStyle, withDefaultSort } from '../../utils/utility';
import {
  clearErrorBoiler,
  deleteBoiler,
  listBoiler,
} from '../../redux/boiler/boiler_actions';
import BoilerEditModal from '../../modal/boiler/BoilerEditModal';
import BoilerDuplicateModal from '../../modal/boiler/BoilerDuplicateModal';

class BoilerPage extends React.Component {
  constructor(props) {
    super(props);
    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
          ? <span><i className="fas fa-users"/> {t('public')}</span>
          : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'type_name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('efficiency')} (%)</b>,
        accessor: 'efficiency',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('compliance')}</b>,
        accessor: 'compliance',
        Cell: row => (row.value !== null && row.value !== undefined) ? t(String(row.value).toLowerCase()) : '-',
        width: 90,
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'state',
        Cell: row => <span className={getStatusStyle(row.value)}>{t(String(row.value).toLowerCase())}</span>,
        width: 90,
        ...textColumn,
      },
      {
        Header: () => <b>{t('cfp')}<br />({t('kgCO2eq per unit')})</b>,
        accessor: 'cfp_value',
        Cell: row => `${Number(row.value || 0)} ${row.original.cfp_unit || ''}`,
      },
    ];

    this.state = {
      selectedInstance: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          id="hot-water-boiler-create"
          data-toggle="modal"
          data-target="#create-boiler"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create boiler')}</span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listBoiler(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category.value],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: instance,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      t,
      errorMessage,
    } = this.props;

    const breadcrumbItems = [
      { name: t('boiler'), path: '/hot_water_system/boiler' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_boiler.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <BoilerCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <BoilerEditModal
          boiler={instance}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <BoilerDuplicateModal
          item={instance}
          show={isShowDuplicateModal}
          title={t('copy boiler')}
          label={t('new boiler name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete boiler')}
          body={`${t('do you want to delete')} ${instance ? instance.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? `${t('deleting')}...` : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteBoiler(instance)}
        />
        <h1>{t('boiler')}</h1>
        <div style={{ backgroundColor: 'white' }}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              id="hot-water-boiler-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, this.state.categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={this.state.categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(this.search.filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.instances}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const boilerState = state.hotWaterSystem.boiler;
  return {
    instances: boilerState.orderedIds.map(id => boilerState.items[id]),
    filteredCount: boilerState.filteredCount,
    isLoading: boilerState.isLoading,
    isCreating: boilerState.isCreating,
    isEditing: boilerState.isEditing,
    isDeleting: boilerState.isDeleting,
    isDuplicating: boilerState.isDuplicating,
    errorMessage: boilerState.errorMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  listBoiler: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listBoiler(pageSize, page, sorted, filtered, isPublic))
    ),
  deleteBoiler: boiler =>
    defaultRejectHandler(dispatch(deleteBoiler(boiler.id))),
  clearError: () => dispatch(clearErrorBoiler()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BoilerPage)
);



// WEBPACK FOOTER //
// ./src/pages/boiler/BoilerPage.js